import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { useMutation } from '@tanstack/react-query';

import { fetchWithTimeout, REQUEST_TIMEOUT } from '../helpers/apiHelper';
import { trackAI } from '../helpers/telemetryHelper';

type Vars = { baseUrl?: string | null; callbackPath: string; timeout?: number };
type Out = number | undefined;

export function useHandleCallbackUrl() {
  return useMutation<Out, Error, Vars>({
    mutationFn: async ({ baseUrl, callbackPath, timeout = REQUEST_TIMEOUT }) => {
      const uri = baseUrl ? `${baseUrl}${callbackPath}` : callbackPath;

      if (!callbackPath.includes('advisoryQuoteId')) {
        navigator.sendBeacon(uri);
        return undefined;
      }

      const res = await fetchWithTimeout(uri, { method: 'POST', timeout });
      return res.status;
    },
    onError: (error, { baseUrl, callbackPath }) => {
      const uri = baseUrl ? `${baseUrl}${callbackPath}` : callbackPath;
      trackAI(`Request failed for '${uri}' with error message: '${error.message}'`, SeverityLevel.Error);
    },
    retry: 0,
  });
}
